import React, {Component} from 'react'
import CasoSummary from './CasoSummary'
import testData from '../../summary.json'

class CasoSidebarInfo extends Component{
    constructor(props){
        super(props)
        this.state = {
            options: []
        }
    }
    componentWillReceiveProps(nextProps) {

        this.setState({options: nextProps.options})
    }
    render(){
        return(
            <CasoSummary summary={this.props.options} addresses={this.props.addresses} />
        )
    }
}

export default CasoSidebarInfo


// WEBPACK FOOTER //
// ./resources/assets/js/components/casos/CasoSidebarInfo.jsx